import { render, staticRenderFns } from "./PastDueClients.vue?vue&type=template&id=349c84b4&"
import script from "./PastDueClients.vue?vue&type=script&lang=js&"
export * from "./PastDueClients.vue?vue&type=script&lang=js&"
import style0 from "./PastDueClients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports